import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <p>Copyright &copy; {new Date().getFullYear()} Freecourso</p>
    </footer>
  );
};

export default Footer;
